/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHomeRepairServiceIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-home-repair-service"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.32 7.35L14.68 7.35L14.68 5.85Q14.68 5.85 14.68 5.85Q14.68 5.85 14.68 5.85L9.32 5.85Q9.32 5.85 9.32 5.85Q9.32 5.85 9.32 5.85ZM2.5 20.8Q1.95 20.8 1.56 20.41Q1.18 20.02 1.18 19.48L1.18 15.4L5.83 15.4L5.83 15.4Q5.83 15.82 6.11 16.11Q6.4 16.4 6.83 16.4L7.47 16.4Q7.9 16.4 8.19 16.11Q8.47 15.82 8.47 15.4L8.47 15.4L15.53 15.4L15.53 15.4Q15.53 15.82 15.81 16.11Q16.1 16.4 16.52 16.4L17.18 16.4Q17.6 16.4 17.89 16.11Q18.18 15.82 18.18 15.4L18.18 15.4L22.82 15.4L22.82 19.48Q22.82 20.02 22.44 20.41Q22.05 20.8 21.5 20.8ZM1.18 13.4L1.18 10Q1.18 8.9 1.95 8.13Q2.73 7.35 3.83 7.35L6.67 7.35L6.67 5.85Q6.67 4.75 7.45 3.98Q8.22 3.2 9.32 3.2L14.68 3.2Q15.78 3.2 16.55 3.98Q17.32 4.75 17.32 5.85L17.32 7.35L20.18 7.35Q21.27 7.35 22.05 8.13Q22.82 8.9 22.82 10L22.82 13.4L18.18 13.4L18.18 12.75Q18.18 12.32 17.89 12.04Q17.6 11.75 17.18 11.75L16.52 11.75Q16.1 11.75 15.81 12.04Q15.53 12.32 15.53 12.75L15.53 13.4L8.47 13.4L8.47 12.75Q8.47 12.32 8.19 12.04Q7.9 11.75 7.47 11.75L6.83 11.75Q6.4 11.75 6.11 12.04Q5.83 12.32 5.83 12.75L5.83 13.4Z" fill={color} />
    </svg>
  );
}
